import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { isUndefined } from 'lodash';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { VisitorModel } from 'client/data/models/visitor';
import { AdsModel } from 'client/data/models/ads';
import { Link } from 'site-modules/shared/components/link/link';

import './privacy-global-disclaimer.scss';

const ADHESION_SPACE = {
  true: '-65px',
  false: '-105px',
};

function PrivacyGlobalDisclaimerUI({
  privacyAccepted,
  hasAdhesionBanner,
  isMobile,
  disablePrivacyDisclaimer,
  setModelValue,
}) {
  const [isClosed, setIsClosed] = useState(false);

  function acceptPrivacy() {
    setIsClosed(true);

    setTimeout(() => {
      setModelValue('privacyAccepted', VisitorModel, 'true');
    });
  }

  if (disablePrivacyDisclaimer || isUndefined(privacyAccepted) || privacyAccepted) {
    return null;
  }

  return (
    <div
      className={classnames('privacy-global-disclaimer justify-content-center mb-1 px-1 left-0 right-0 bottom-0', {
        invisible: isClosed,
      })}
      style={{ display: 'none', transform: `translateY(${hasAdhesionBanner ? ADHESION_SPACE[isMobile] : 0})` }}
      role="region"
      aria-label="Privacy Disclaimer"
    >
      <div className="privacy-content-wrapper">
        <div
          className="privacy-content pos-r rounded-8 bg-blue-100 pt-2_5 pt-md-1_75 pb-1_5 px-1_5"
          data-tracking-parent="privacy-disclaimer"
        >
          <div className="heading-4 mb-0_5" role="heading" aria-level={2}>
            Your Privacy
          </div>
          <div className="privacy-text medium text-cool-gray-10">
            By accessing this website, you acknowledge that Edmunds and its third party business partners may use
            cookies, pixels, and similar technologies to collect information about you and your interactions with the
            website as described in our{' '}
            <Link to="/about/privacy.html" className="text-underline">
              Privacy Statement
            </Link>
            , and you agree that your use of the website is subject to our{' '}
            <Link to="/about/visitor-agreement.html" className="text-underline">
              Visitor Agreement
            </Link>
            .
          </div>
          <button
            onClick={acceptPrivacy}
            className="close-btn d-flex align-items-start justify-content-end text-cool-gray-10 size-20 bg-transparent border-0 rounded-8 pos-a top-0 left-0 right-0 pt-0_75 pe-1"
            data-tracking-id="close_privacy_disclaimer"
          >
            <span className="d-flex align-items-center">
              Close <span className="visually-hidden">disclaimer</span>
              <i className="icon-cross2 ms-0_25" aria-hidden />
            </span>
          </button>
        </div>
      </div>
    </div>
  );
}

PrivacyGlobalDisclaimerUI.propTypes = {
  setModelValue: PropTypes.func.isRequired,
  privacyAccepted: PropTypes.bool,
  hasAdhesionBanner: PropTypes.bool,
  disablePrivacyDisclaimer: PropTypes.bool,
  isMobile: PropTypes.bool,
};

PrivacyGlobalDisclaimerUI.defaultProps = {
  privacyAccepted: undefined,
  hasAdhesionBanner: false,
  disablePrivacyDisclaimer: false,
  isMobile: false,
};

const mapStateToProps = state => ({
  isMobile: state.mobile,
  disablePrivacyDisclaimer: state.featureFlags['disable-privacy-disclaimer'],
});

export const PrivacyGlobalDisclaimer = connect(mapStateToProps)(
  connectToModel(PrivacyGlobalDisclaimerUI, {
    privacyAccepted: bindToPath('privacyAccepted', VisitorModel),
    hasAdhesionBanner: bindToPath('adhesionBanner', AdsModel),
  })
);
